export default __webpack_public_path__ + "static/media/twitter.2fa222d0.svg";